import React, { useEffect, useState } from 'react';

const TeamMain = () => {
    const [teamMembers, setTeamMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/faculties/`)
            .then((res) => {
                if (!res.ok) throw new Error('Network response was not ok');
                return res.json();
            })
            .then((data) => {
                const mapped = data.map((member, idx) => ({
                    id: member.id || idx,
                    category: member.caregory || member.category || '',
                    image: member.photo,
                    name: member.name,
                    qualification: member.qualifications,
                    experience: member.experiece || member.experience,
                }));
                setTeamMembers(mapped);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    const groupedMembers = teamMembers.reduce((acc, member) => {
        if (!acc[member.category]) acc[member.category] = [];
        acc[member.category].push(member);
        return acc;
    }, {});

    if (loading) return <div className="flex items-center justify-center min-h-screen text-xl">Loading...</div>;
    if (error) return <div className="flex items-center justify-center min-h-screen text-xl text-red-500">Error: {error}</div>;

    return (
        <section className="w-full py-12 overflow-x-hidden bg-gray-50">
            

            <div className="max-w-screen-xl px-4 mx-auto sm:px-6 lg:px-8">
                {Object.entries(groupedMembers).map(([category, members]) => (
                    <div key={category} className="mb-16">
                        <div className="flex justify-center mb-8 ">
                            <h2 className="pb-2 text-3xl font-extrabold text-gray-800 capitalize border-b-4 border-orange-600 md:text-4xl">
                                {category}
                            </h2>
                        </div>

                        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 ">
                            {members.map((member) => (
                                <div key={member.id} className="w-full h-full p-4 transition bg-white border-b-2 shadow-md border-b-orange-900 rounded-xl hover:shadow-lg">
                                    <h3 className="mb-2 text-lg font-bold text-orange-800">Name: {member.name}</h3>
                                    <p className="mb-1 text-gray-700">
                                        <span className="font-semibold">Qualification:</span> {member.qualification}
                                    </p>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Experience:</span> {member.experience}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default TeamMain;
